class FirstLogin
{
	private person: { [ key: string ]: any };
	private account: { [ key: string ]: any };
	private logout: boolean;
	private m_Address: AddressManager;
	private m_Profile: ProfileManager;
	private m_Call: boolean[];
	private m_Calls: number;
	private m_Modal?: Dialog;
	private m_ToLogoutOut: boolean;

	constructor( person: { [ key: string ]: any }, account: { [ key: string ]: any } )
	{
		this.person					= person;
		this.account				= account;
		this.logout					= false;

		this.m_Address			= new AddressManager( this.account.Company, this.person.Address, 400, { create: true, update: true, delete: true } );
		this.m_Profile			= new ProfileManager( this.person );
		this.m_Call					= [ false, false ];
		this.m_Calls				= 0;
		this.m_ToLogoutOut	= true;
	}

	public createModal()
	{
		const submitBtn = new Button(
			{
				title: app.getMessage( 'Aux.SAVE_BTN' ),
				style: 'success',
				on:
				{
					click: (
						(fl: FirstLogin) : (text: string) => void =>
						{
							return () : void =>
							{
								if ( !fl.m_Call[ 0 ] ) { new Wollmilch.AJAX(
									{
										url: 'account/changePassword/' + fl.account.ID,
										method: 'PATCH',
										data: null,
										on:
										{
											beforeSend( options: Wollmilch.IAJAXOptions ) { options.data = { password: $( '#FIRST_LOGIN_PASS_1' ).val() }; },
											success( text: string ) { try { const obj = JSON.parse( text ); } catch ( e ) { return; } fl.setSuccessCall( 0 ); }
										}
									}
								).send();
								}

								const items	= this.m_Address.getItems();
								let ii: number = 0;
								for ( const i in items )
								{
									let callID: number	= 2 + ii++;

									const item		= items[ i ];

									if ( fl.m_Call.length < callID + 1 )
									{
										callID = fl.m_Call.push( false ) - 1;
									}

									if ( !fl.m_Call[ callID ] ) { ( (id: number) =>
										{
											new Wollmilch.AJAX(
												{
													url: item.State() === 0 ? 'address/new/' + item.Type() : 'address/edit/' + item.ID(),
													method: item.State() === 0 ? 'POST' : 'PATCH',
													data: null,
													on:
													{
														beforeSend( o: Wollmilch.IAJAXOptions )
														{
															o.data = {};
															const inputs = item.getInputs();
															for ( const j in inputs )
															{
																const name = inputs[ j ].attr( 'name' );
																o.data[ name || '__fallback' ] = inputs[ j ].val();
															}
														},
														success( text )
														{
															let obj: Wollmilch.ResponseObject;
															try
															{
																obj = JSON.parse( text );
															}
															catch ( e )
															{
																app.addNotify(
																	{
																		title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																		body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_FAILED' ) ],
																		context: 'success',
																		timeout: Number(app.getConfigValue("ToastTimeout"))
																	}
																);

																return;
															}

															if ( !obj.success )
															{
																return;
															}

															app.addNotify(
																{
																	title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																	body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_SUCCESS' ) ],
																	context: 'success',
																	timeout: Number(app.getConfigValue("ToastTimeout"))
																}
															);

															if ( item.State() == 0 )
															{
																new Wollmilch.AJAX(
																	{
																		url: 'organization/linkAddress/' + fl.person.ID + '/' + obj.data.ID,
																		method: 'POST',
																		data: null,
																		on:
																		{
																			beforeSend( o: Wollmilch.IAJAXOptions ) { item.setState( AddressListItem.EDIT ); },
																			success( text )
																			{
																				try
																				{
																					const obj_ = JSON.parse( text );

																					if ( !obj_.success )
																					{
																						throw new Error();
																					}
																				}
																				catch ( e )
																				{
																					app.addNotify(
																						{
																							title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																							body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_FAILED' ) ],
																							context: 'success',
																							timeout: Number(app.getConfigValue("ToastTimeout"))
																						}
																					);

																					return;
																				}

																				fl.setSuccessCall( id );
																				app.addNotify(
																					{
																						title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																						body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_SUCCESS' ) ],
																						context: 'success',
																						timeout: Number(app.getConfigValue("ToastTimeout"))
																					}
																				);
																			}
																		}
																	}
																).send();
															}
															else
															{
																fl.setSuccessCall( id );
																app.addNotify(
																	{
																		title: [ app.getSpanMessage( 'AddressManager.TITLE.SAVE' ) ],
																		body: [ app.getSpanMessage( 'AddressManager.ACTION.SAVE_SUCCESS' ) ],
																		context: 'success',
																		timeout: Number(app.getConfigValue("ToastTimeout"))
																	}
																);
															}
														}
													}
												}
											).send();
										}
									)(callID);
									}
								}

								if ( !fl.m_Call[ 1 ] ) { new Wollmilch.AJAX(
									{
										url: 'organization/edit/' + fl.person.ID,
										method: 'PATCH',
										data: null,
										on:
										{
											beforeSend: ( o: Wollmilch.IAJAXOptions ): void =>
											{
												o.data = {};
												const inputs = fl.m_Profile.getInputs();

												for ( const j in inputs )
												{
													const name = inputs[ j ].attr( 'name' );
													o.data[ name || '__fallback' ] = inputs[ j ].val();
												}
											},
											success: ( text: string ): void =>
											{
												try
												{
													const obj = JSON.parse( text );
													
													if ( obj.success )
													{
														fl.setSuccessCall( 1 );
													}
												}
												catch ( e )
												{
													return;
												}
											}
										}
									}
								).send();
								}
							};
						}
					)( this )
				}
			}
		);
		const abortBtn = new Button(
			{
				title: app.getMessage( 'Aux.ABORT_BTN' ),
				style: 'danger',
				on:
				{
					click: () : void =>
					{
						app.getAuthenticationManager().logout();
						this.logout = true;
					}
				}
			}
		);

		$( abortBtn.getElement() ).attr( 'data-dismiss', 'modal' );

		this.m_Modal = new Dialog(
			{
				closeBtn: true,
				fade: true,
				head: [ ui.h( 3, 'Bitte überprüfen Sie Ihre Profildaten.' ) ],
				body: this.createModalForm(),
				foot: [ submitBtn.getElement(), abortBtn.getElement() ],
				selfRemove: true
			}
		);

		$( this.m_Modal.getElement() ).on(
			'hide.bs.modal',
			() =>
			{
				if ( !this.logout && this.m_ToLogoutOut )
				{
					app.getAuthenticationManager().logout();
					this.logout = true;
				}
			}
		);

		$( document.body ).append( this.m_Modal.getElement() );

		$( this.m_Modal.getElement() )
			.find( '.modal-dialog' )
			.css( 'min-width', '75%' );

		$( this.m_Modal.getElement() ).modal( 'show' );
	}

	private setSuccessCall( idx: number ): void
	{
		this.m_Call[ idx ] = true;
		this.m_Calls++;

		if ( this.m_Calls == this.m_Call.length )
		{
			this.checkAllCallsAndDispose();
		}
	}

	private checkAllCallsAndDispose(): void
	{
		if ( !this.m_Modal ) { return; }

		this.m_ToLogoutOut = false;

		$( this.m_Modal.getElement() ).modal( 'hide' );

		// app.addNotify(
		// 	{
		// 		title: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_PROCESS' ) ],
		// 		body: [ app.getSpanMessage( 'AuthenticationManager.LOGIN_SUCCESS' ) ],
		// 		context: 'success',
		// 		timeout: Number(app.getConfigValue("ToastTimeout"))
		// 	}
		// );

		$('#LOGIN_BTN_ID').hide();
		$('#LOGOUT_BTN_ID').show();
		$('#LOGOUT_BTN_ID').on( 'click', () => { app.getAuthenticationManager().logout(); return true; } );

		app.getAuthenticationManager().setInfoBar();
	}

	private createModalForm() : HTMLElement[]
	{
		const passform = new Form(
			{
				tag: 'div',
				orientation: 'horizontal'
			}
		);

		const passwordGroup = passform.newFormGroup( [ 1, 1 ] );

		passwordGroup.addItem( {
			input: new InputPassword(
				{
					id: 'FIRST_LOGIN_PASS_1',
					name: 'password_1',
					disabled: false,
					value: ''
				}
			)
		} );

		passwordGroup.addItem(
			{
				input: new InputPassword(
					{
						id: 'FIRST_LOGIN_PASS_2',
						name: 'password_2',
						disabled: false,
						value: ''
					}
				)
			}
		);

		const container	= $( document.createElement( 'div' ) );
		const row				= $( document.createElement( 'div' ) );
		const left			= $( document.createElement( 'div' ) );
		const right			= $( document.createElement( 'div' ) );

		container.addClass( 'container-fluid' );

		row.addClass( 'row' );
		left.addClass( 'col-xs-12 col-md-6' );
		right.addClass( 'col-xs-12 col-md-6' );

		container.append( row );
		row.append( left );
		row.append( right );

		right.append( this.m_Address.getElement() );
		left.append( this.m_Profile.getEditingFormular( true, false ) );

		return [
			ui.h( 4, 'Bitte wählen Sie ein Passwort' ),
			passform.getElement(),
			document.createElement( 'hr' ),
			container[ 0 ]
		];
	}
}
